module.exports = __webpack_public_path__ + "c1f38333a576aa35fb18d35d45b6fa31.png";